import RelatedEntitiesContainer from './RelatedEntitiesContainer';
export default RelatedEntitiesContainer;
